import { Box, Drawer, Grid, List, } from "@mui/material";
import { useContext } from "react";
import { linear_content_style, linear_item, linear_v, } from "../libs/linear-layout/LinearLayout";
import Title from "../libs/rhf-mui/ui/Title";
import { MainFormContext  } from "./MainForm";

const DRAWER_WDITH = 300;

type Props = {};

const MainMenu = ({ ...props }: Props) => {

  const mMainForm_Context = useContext(MainFormContext );

  const CurrBreakPoint = mMainForm_Context?.ShowAppMenuBreakPoint == null ? "" : mMainForm_Context?.ShowAppMenuBreakPoint;

  return (
    <>
      {render_AppMenuDrawer()}
      {render_FixedAppMenu()}
    </>
  );

  function render_AppMenuDrawer() {
    return (
      <Drawer
        sx={{
          display: { xs: "block", [CurrBreakPoint]: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: DRAWER_WDITH,
          },
        }}
        variant="temporary"
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        anchor={"left"}
        open={mMainForm_Context?.IsAppMenuOpen}
        onClose={() => {
          mMainForm_Context?.set_IsAppMenuOpen(false);
        }}
      >
        {render_AppMenuContent()}
      </Drawer>
    );
  }

  function render_FixedAppMenu() {
    return (
      <Box
        sx={{
          ...linear_content_style,
          width: DRAWER_WDITH,
          display: { xs: "none", [CurrBreakPoint]: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: DRAWER_WDITH,
          },
          borderRight: "1px solid #EAEAEA",
        }}
      >
        {render_AppMenuContent()}
      </Box>
    );
  }

  function render_AppMenuContent() {
    return (
      <Grid {...linear_v}>
        <Grid {...linear_item} flex={1}>
          {render_AppMenuList()}
        </Grid>
      </Grid>
    );
  }

  function render_AppMenuList() {
    return (
      <div>
        <Grid {...linear_item}>
          <Box height={96} p={2} display="flex" alignItems={"center"}>
            <Title>問卷系統</Title>
          </Box>
        </Grid>
        <List>
        </List>

      </div>
    );
  }
};

export default MainMenu;


















// XXX ------------------------------------------
// export const APP_MENU_ITEMS: AppMenuItem[] = [

//   { url: "", text: "-----------------------------" },
//   { url: "/FrmProjectList", text: "場次列表", page: <FrmProjectList/> },
//   { url: "/FrmProjectEditor", text: "", page: <FrmProjectEditor/> },

//   { url: "/FrmUniFuncDefinition", text: "問卷定義", page: <FrmUniFuncDefinition/> },
//   { url: "/FrmUniFormDefinition", text: "", page: <FrmUniFormDefinition/> },
//   { url: "/FrmUniInputDefinition", text: "", page: <FrmUniInputDefinition/> },

//   { url: "/FrmSpwkExportTest", text: "匯出功能測試", page: <FrmSpwkExportTest/> },

//   { url: "/FrmUniQuestionnaire", text: "", page: <FrmUniQuestionnaire/> },
//   { url: "/FrmSpwkQuestionnaire", text: "", page: <FrmSpwkQuestionnaire/> },

//   { url: "/FrmSpwkQuestionnaireKYLe", text: "", page: <FrmSpwkQuestionnaireKYLe/> },
//   { url: "/FrmSpwkQuest", text: "", page: <FrmSpwkQuest/> },

//   { url: "/FrmSpwkQuest2", text: "", page: <FrmSpwkQuest2/> },

//   { url: "/FrmTest", text: "FrmTest", page: <FrmTest/> },

//   { url: "/error", text: "", page: <FrmError/> },

//   { url: "", text: "-----------------------------" },
//   { url: "", text: "功能名稱" },
//   { url: "/react-demo", text: "REACT-DEMO", page: <FrmDemo_Index /> },
//   { url: "/FrmBlank", text: "FrmBlank", page: <FrmBlank/> },
//   { url: "/home", text: "Home", page: <FrmHomePage/> },
//   { url: "/blank-entity", text: "FrmBlankEntity", page: <FrmBlankEntity /> },

//   { url: "/FrmMemberLogin", text: "FrmMemberLogin", page: <UcMemberLogin/> },

//   { url: "/FrmAdminLogin", text: "FrmAdminLogin", page: <UcAdminLogin/> },
//   { url: "/CustomUrl", text: "產生網址", page: <UcCustomUrl/> },

//   // { url: "/dev", text: "", page: <FrmDevMenu/> },

// ];

// {

// APP_MENU_ITEMS.push({url: "/", text: "FrmHomePage", page: <FrmHomePage/>}):
// APP_MENU_ITEMS.push({url: "", text: "Blank", page: <Blank/>})
// }
